module.exports = __webpack_public_path__ + "img/news-02.b491932e.jpg";